(function() {
  'use strict';

  var drawer = document.getElementById('cart-drawer');
  var backdrop = document.getElementById('cart-drawer-backdrop');
  var closeBtn = document.getElementById('cart-drawer-close');
  var drawerContent = document.getElementById('cart-drawer-content');
  var drawerBody = document.getElementById('cart-drawer-body');
  var drawerFooter = document.getElementById('cart-drawer-footer');
  var isOpen = false;

  var settings = window.cartDrawerSettings || {};
  var freeShippingThreshold = settings.freeShippingThreshold || 50000;
  var currencySymbol = settings.currencySymbol || 'R$';
  var pixDiscountPercentage = Math.max(0, Number(settings.pixDiscountPercentage || 0));
  var dispatchCountdownEnabled = settings.dispatchCountdownEnabled !== false;
  var dispatchCutoffHour = Math.min(23, Math.max(0, Math.round(Number(settings.dispatchCutoffHour || 9))));
  var dispatchCutoffMinute = Math.min(59, Math.max(0, Math.round(Number(settings.dispatchCutoffMinute || 0))));
  var giftCampaignEnabled = settings.giftCampaignEnabled === true;
  var giftCampaignMinQuantity = Math.max(1, Math.round(Number(settings.giftCampaignMinQuantity || 2)));
  var giftCampaignCollections = Array.isArray(settings.giftCampaignCollections) ? settings.giftCampaignCollections : [];
  var giftCampaignRewardCollections = Array.isArray(settings.giftCampaignRewardCollections) ? settings.giftCampaignRewardCollections : [];
  var giftCampaignDestinationUrl = settings.giftCampaignDestinationUrl || '/collections/all';
  var giftCollectionProductsPromise = null;
  var giftRewardProductsPromise = null;
  var giftCampaignSyncing = false;
  var giftCampaignRenderToken = 0;
  var shippingStorageKey = 'snap_shipping_cep';
  var shippingCookieName = 'snap_shipping_cep';
  var shippingCepSyncBound = false;
  var discountStorageKey = 'snap_cart_discount_code';
  var discountSuggestion = 'PRIMEIRACOMPRA';

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return currencySymbol + ' ' + value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function getPixPrice(cents) {
    var multiplier = Math.max(0, 100 - pixDiscountPercentage);
    return Math.round(Number(cents || 0) * multiplier / 100);
  }

  function renderPixBadge() {
    if (pixDiscountPercentage <= 0) return '';
    return '<span class="inline-flex items-center rounded bg-green-50 px-2 py-0.5 text-xs font-semibold text-green-700">no PIX</span>';
  }

  function getVariantTitle(item) {
    if (item.variant_options && item.variant_options.length > 0) {
      var filtered = item.variant_options.filter(function(opt) {
        return opt && opt !== 'Default Title';
      });
      if (filtered.length > 0) return filtered.join(' / ');
    }
    if (!item.variant_title || item.variant_title === 'Default Title') return '';
    return item.variant_title;
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function normalizeCep(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatCep(value) {
    var cep = normalizeCep(value);
    return cep.length > 5 ? cep.slice(0, 5) + '-' + cep.slice(5) : cep;
  }

  function getSavedCep() {
    var savedCep = '';
    try {
      savedCep = window.localStorage.getItem(shippingStorageKey) || '';
    } catch (e) {
      savedCep = '';
    }

    if (!savedCep) {
      var cookieMatch = document.cookie.match(new RegExp('(?:^|; )' + shippingCookieName + '=([^;]*)'));
      savedCep = cookieMatch ? decodeURIComponent(cookieMatch[1]) : '';
    }

    return normalizeCep(savedCep);
  }

  function saveCep(value) {
    var cep = normalizeCep(value);
    if (cep.length !== 8) return;

    try {
      window.localStorage.setItem(shippingStorageKey, cep);
    } catch (e) {
      // localStorage can be unavailable in restricted browser contexts.
    }

    document.cookie = shippingCookieName + '=' + encodeURIComponent(cep) + '; path=/; max-age=31536000; SameSite=Lax';
    document.dispatchEvent(new CustomEvent('snap:shipping-cep:updated', { detail: { cep: cep } }));
  }

  function normalizeDiscountCode(value) {
    return String(value || '').trim().replace(/\s+/g, '').toUpperCase().slice(0, 64);
  }

  function getSavedDiscountCode() {
    try {
      return normalizeDiscountCode(window.localStorage.getItem(discountStorageKey) || '');
    } catch (e) {
      return '';
    }
  }

  function saveDiscountCode(value) {
    var code = normalizeDiscountCode(value);
    try {
      if (code) {
        window.localStorage.setItem(discountStorageKey, code);
      } else {
        window.localStorage.removeItem(discountStorageKey);
      }
    } catch (e) {
      // localStorage can be unavailable in restricted browser contexts.
    }
    updateCheckoutDiscountLink();
    return code;
  }

  function getCartDiscountCodes(cartData, onlyApplicable) {
    if (!cartData || !Array.isArray(cartData.discount_codes)) return [];
    return cartData.discount_codes
      .filter(function(discount) {
        return discount && discount.code && (!onlyApplicable || discount.applicable);
      })
      .map(function(discount) {
        return normalizeDiscountCode(discount.code);
      })
      .filter(Boolean);
  }

  function getActiveDiscountCode(cartData) {
    var appliedCodes = getCartDiscountCodes(cartData, true);
    if (appliedCodes.length > 0) return appliedCodes[0];
    return getSavedDiscountCode();
  }

  function getDiscountDescription(cartData, code) {
    if (!cartData || !Array.isArray(cartData.discount_codes) || !code) return null;
    var normalizedCode = normalizeDiscountCode(code);
    return cartData.discount_codes.find(function(discount) {
      return normalizeDiscountCode(discount.code) === normalizedCode;
    }) || null;
  }

  function fetchCartData() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function(res) {
      if (!res.ok) throw new Error('Cart unavailable');
      return res.json();
    });
  }

  function updateCartDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: code || '' })
    })
      .then(function(res) {
        return res.json().then(function(data) {
          if (!res.ok || (data && data.status && data.status !== 200)) {
            throw new Error((data && (data.description || data.message)) || 'Discount update failed');
          }
          return data;
        });
      })
      .then(function(cartData) {
        if (cartData && Array.isArray(cartData.items)) return cartData;
        return fetchCartData();
      });
  }

  function getCheckoutUrl() {
    var code = getSavedDiscountCode();
    if (!code) return '/checkout';
    return '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  }

  function updateCheckoutDiscountLink() {
    var checkoutBtn = document.querySelector('[data-cart-drawer-checkout]');
    if (checkoutBtn) checkoutBtn.setAttribute('href', getCheckoutUrl());
  }

  function getBrazilStateName(uf) {
    var states = {
      AC: 'Acre',
      AL: 'Alagoas',
      AP: 'Amapá',
      AM: 'Amazonas',
      BA: 'Bahia',
      CE: 'Ceará',
      DF: 'Distrito Federal',
      ES: 'Espírito Santo',
      GO: 'Goiás',
      MA: 'Maranhão',
      MT: 'Mato Grosso',
      MS: 'Mato Grosso do Sul',
      MG: 'Minas Gerais',
      PA: 'Pará',
      PB: 'Paraíba',
      PR: 'Paraná',
      PE: 'Pernambuco',
      PI: 'Piauí',
      RJ: 'Rio de Janeiro',
      RN: 'Rio Grande do Norte',
      RS: 'Rio Grande do Sul',
      RO: 'Rondônia',
      RR: 'Roraima',
      SC: 'Santa Catarina',
      SP: 'São Paulo',
      SE: 'Sergipe',
      TO: 'Tocantins'
    };
    return states[String(uf || '').toUpperCase()] || '';
  }

  function buildShippingRatesUrlWithAddress(endpoint, address) {
    var params = new URLSearchParams();
    params.append('shipping_address[zip]', address.zip);
    params.append('shipping_address[country]', 'Brazil');
    params.append('shipping_address[country_code]', 'BR');
    if (address.province) params.append('shipping_address[province]', address.province);
    if (address.province_code) params.append('shipping_address[province_code]', address.province_code);
    if (address.city) params.append('shipping_address[city]', address.city);
    return endpoint + '?' + params.toString();
  }

  function fetchCepAddress(cep) {
    return fetch('https://viacep.com.br/ws/' + encodeURIComponent(cep) + '/json/', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function(res) {
        if (!res.ok) throw new Error('CEP lookup unavailable');
        return res.json();
      })
      .then(function(data) {
        if (!data || data.erro) throw new Error('CEP not found');
        return {
          zip: cep,
          province: getBrazilStateName(data.uf),
          province_code: data.uf || '',
          city: data.localidade || ''
        };
      })
      .catch(function() {
        return { zip: cep };
      });
  }

  function fetchShippingRates(cep, attempt) {
    attempt = attempt || 0;
    var address = typeof cep === 'string' ? { zip: cep } : cep;
    return fetch(buildShippingRatesUrlWithAddress('/cart/async_shipping_rates.json', address), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function(res) {
        if (!res.ok) throw new Error('Shipping rates unavailable');
        return res.json();
      })
      .then(function(data) {
        var rates = data.shipping_rates || [];
        if (rates.length > 0 || attempt >= 1) return rates;
        return new Promise(function(resolve) {
          setTimeout(resolve, 300);
        }).then(function() {
          return fetchShippingRates(address, attempt + 1);
        });
      });
  }

  function calculateShippingRates(cep) {
    return fetchCepAddress(cep).then(function(address) {
      return fetch(buildShippingRatesUrlWithAddress('/cart/prepare_shipping_rates.json', address), {
        method: 'POST',
        headers: { 'Accept': 'application/json' }
      })
        .then(function(res) {
          if (!res.ok) throw new Error('Shipping rates preparation failed');
          return fetchShippingRates(address, 0);
        })
        .catch(function() {
          return fetch(buildShippingRatesUrlWithAddress('/cart/shipping_rates.json', address), {
            headers: { 'Accept': 'application/json' }
          })
            .then(function(res) {
              if (!res.ok) throw new Error('Shipping rates unavailable');
              return res.json();
            })
            .then(function(data) {
              return data.shipping_rates || [];
            });
        });
    });
  }

  function formatShippingRatePrice(rate) {
    if (rate.price != null && rate.price !== '') {
      var numericPrice = Number(String(rate.price).replace(',', '.'));
      if (!isNaN(numericPrice) && numericPrice === 0) return 'GRÁTIS!';
      if (!isNaN(numericPrice)) return formatMoney(Math.round(numericPrice * 100));
    }

    if (rate.price_cents != null) {
      var centsPrice = Number(rate.price_cents);
      if (!isNaN(centsPrice) && centsPrice === 0) return 'GRÁTIS!';
      return formatMoney(centsPrice);
    }
    return '';
  }

  function parseIsoDate(value) {
    var match = String(value || '').match(/(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return null;
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }

  function isBusinessDay(date) {
    var weekday = date.getDay();
    return weekday !== 0 && weekday !== 6;
  }

  function getNextBusinessDay(date) {
    var next = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    do {
      next.setDate(next.getDate() + 1);
    } while (!isBusinessDay(next));
    return next;
  }

  function addBusinessDays(date, days) {
    var target = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    var remaining = Math.max(0, Number(days) || 0);

    while (remaining > 0) {
      target.setDate(target.getDate() + 1);
      if (isBusinessDay(target)) remaining--;
    }

    return target;
  }

  function padTime(value) {
    value = Number(value) || 0;
    return value < 10 ? '0' + value : String(value);
  }

  function formatShortDate(date) {
    if (!date) return '';

    var weekdays = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
    var months = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
    return weekdays[date.getDay()] + ', ' + date.getDate() + '/' + months[date.getMonth()];
  }

  function formatDispatchDate(date) {
    if (!date) return '';

    var weekdays = ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado'];
    var months = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
    return weekdays[date.getDay()] + ', ' + date.getDate() + '/' + months[date.getMonth()];
  }

  function getNextDispatchCutoff(now) {
    var todayCutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), dispatchCutoffHour, dispatchCutoffMinute, 0, 0);

    if (isBusinessDay(now) && now < todayCutoff) {
      return {
        date: todayCutoff,
        isToday: true
      };
    }

    var nextBusinessDay = getNextBusinessDay(now);
    return {
      date: new Date(nextBusinessDay.getFullYear(), nextBusinessDay.getMonth(), nextBusinessDay.getDate(), dispatchCutoffHour, dispatchCutoffMinute, 0, 0),
      isToday: false
    };
  }

  function getDispatchStatus() {
    if (!dispatchCountdownEnabled) return null;

    var now = new Date();
    var cutoff = getNextDispatchCutoff(now);
    var diff = cutoff.date.getTime() - now.getTime();
    var hours = Math.floor(diff / 3600000);
    var minutes = Math.floor((diff % 3600000) / 60000);
    var totalMinutes = Math.ceil(diff / 60000);
    var toneClass = 'text-green-700';

    if (totalMinutes <= 30) {
      toneClass = 'text-red-600';
    } else if (totalMinutes <= 120) {
      toneClass = 'text-orange-700';
    }

    return {
      message: 'Peça em até ' + padTime(hours) + 'h ' + padTime(minutes) + 'min e despacha ' + (cutoff.isToday ? 'hoje' : 'no próximo dia útil'),
      toneClass: toneClass,
      dispatchDate: cutoff.date,
      totalMinutes: totalMinutes,
      isToday: cutoff.isToday,
      isCurrentBusinessDay: isBusinessDay(now)
    };
  }

  function countBusinessDaysUntil(date) {
    if (!date) return null;

    var today = new Date();
    today = new Date(today.getFullYear(), today.getMonth(), today.getDate());

    var target = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    if (target <= today) return 0;

    var days = 0;
    var current = new Date(today);
    while (current < target) {
      current.setDate(current.getDate() + 1);
      var weekday = current.getDay();
      if (weekday !== 0 && weekday !== 6) days++;
    }

    return days;
  }

  function formatDeliveryRangeAsPrazo(deliveryRange) {
    var dates = String(deliveryRange || '').match(/\d{4}-\d{2}-\d{2}/g);
    if (!dates || dates.length === 0) return '';

    var firstPrazo = countBusinessDaysUntil(parseIsoDate(dates[0]));
    var lastPrazo = countBusinessDaysUntil(parseIsoDate(dates[dates.length - 1]));
    if (firstPrazo == null || lastPrazo == null) return '';

    if (firstPrazo === lastPrazo) {
      return firstPrazo <= 1 ? 'Prazo: 1 dia útil' : 'Prazo: ' + firstPrazo + ' dias úteis';
    }

    return 'Prazo: ' + firstPrazo + ' a ' + lastPrazo + ' dias úteis';
  }

  function formatDispatchMessage(status) {
    if (!status) return '';

    if (!status.isToday && (!status.isCurrentBusinessDay || status.totalMinutes > 1440)) {
      return 'Despacha na ' + formatDispatchDate(status.dispatchDate);
    }

    return status.message;
  }

  function formatDeliveryRangeAsDate(deliveryRange, dispatchStatus) {
    var dates = String(deliveryRange || '').match(/\d{4}-\d{2}-\d{2}/g);
    if (!dates || dates.length === 0) return '';

    var firstPrazo = countBusinessDaysUntil(parseIsoDate(dates[0]));
    var lastPrazo = countBusinessDaysUntil(parseIsoDate(dates[dates.length - 1]));
    if (firstPrazo == null || lastPrazo == null) return '';

    var dispatchDate = dispatchStatus && dispatchStatus.dispatchDate
      ? dispatchStatus.dispatchDate
      : new Date();
    var firstDate = addBusinessDays(dispatchDate, firstPrazo);
    var lastDate = addBusinessDays(dispatchDate, lastPrazo);

    if (firstDate.getTime() === lastDate.getTime()) {
      return 'Chega até ' + formatShortDate(firstDate);
    }

    return 'Chega entre ' + formatShortDate(firstDate) + ' e ' + formatShortDate(lastDate);
  }

  function renderShippingRates(rates) {
    if (!rates || rates.length === 0) {
      return '<p class="text-xs text-gray-500">Nenhuma opção de frete disponível para este CEP.</p>';
    }

    return rates.map(function(rate) {
      var title = rate.presentment_name || rate.name || rate.code || 'Frete';
      var price = formatShippingRatePrice(rate);
      var delivery = rate.delivery_range ? String(rate.delivery_range) : '';
      var prazo = formatDeliveryRangeAsPrazo(delivery);
      var dispatch = getDispatchStatus();
      var deliveryDate = formatDeliveryRangeAsDate(delivery, dispatch);
      var deliveryHtml = [
        deliveryDate ? '<span class="mt-1 block text-xs font-semibold text-gray-900">' + escapeHtml(deliveryDate) + '</span>' : '',
        prazo ? '<span class="block text-[11px] text-gray-500">' + escapeHtml(prazo) + '</span>' : '',
        dispatch ? '<span class="mt-2 block rounded bg-gray-50 px-2 py-1 text-[11px] font-semibold leading-snug ' + dispatch.toneClass + '" data-shipping-dispatch-timer="true">' + escapeHtml(formatDispatchMessage(dispatch)) + '</span>' : ''
      ].join('');
      var priceClass = price === 'GRÁTIS!' ? 'text-green-700' : 'text-gray-900';

      return (
        '<div class="flex items-start justify-between gap-3 rounded border border-gray-100 px-3 py-2">' +
          '<span class="text-xs text-gray-700">' + escapeHtml(title) + deliveryHtml + '</span>' +
          '<span class="text-xs font-semibold ' + priceClass + ' whitespace-nowrap">' + escapeHtml(price) + '</span>' +
        '</div>'
      );
    }).join('');
  }

  function refreshDispatchTimers() {
    var status = getDispatchStatus();
    if (!status) return;

    document.querySelectorAll('[data-shipping-dispatch-timer]').forEach(function(element) {
      element.classList.remove('text-gray-600', 'text-green-700', 'text-orange-700', 'text-red-600');
      element.classList.add(status.toneClass);
      element.textContent = formatDispatchMessage(status);
    });
  }

  function getKitPropertiesHtml(item, variantTitle) {
    if (!item.properties) return '';
    if (item.properties.Kit) {
      var componentHtml = '';
      if (variantTitle) {
        componentHtml += '<p class="text-xs text-gray-500 mt-0.5">' + escapeHtml(variantTitle) + '</p>';
      }
      componentHtml += '<p class="text-xs text-gray-400 mt-1">Kit: ' + escapeHtml(item.properties.Kit) + '</p>';
      return componentHtml;
    }
    var kitItems = [];
    Object.keys(item.properties).forEach(function(key) {
      // Accept both new public properties and legacy private properties.
      if (/^_?Item\s/.test(key)) {
        var raw = String(item.properties[key]);
        if (item.product_title) {
          var escaped = item.product_title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          raw = raw.replace(new RegExp('^' + escaped + '\\s*—\\s*'), '');
        }
        kitItems.push(raw);
      }
    });
    if (kitItems.length === 0) return '';
    var html = '<ul class="text-xs text-gray-500 mt-1 space-y-0.5">';
    kitItems.forEach(function(val) {
      var display = val.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/null/g, '—');
      html += '<li>' + display + '</li>';
    });
    html += '</ul>';
    return html;
  }

  function isKitItem(item) {
    return item.properties && item.properties['_kit_type'];
  }

  function getKitId(item) {
    return item && item.properties && item.properties['_kit_id'];
  }

  function isCampaignGift(item) {
    return item && item.properties && item.properties['_gift_campaign'] === 'esquenta-linho';
  }

  function getCollectionProductIds(handles) {
    return Promise.all(handles.map(function(handle) {
        var page = 1;
        var ids = [];
        function loadPage() {
          return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + page, {
            headers: { 'Accept': 'application/json' }
          }).then(function(res) {
            if (!res.ok) throw new Error('Não foi possível carregar a coleção da campanha');
            return res.json();
          }).then(function(data) {
            var products = data && Array.isArray(data.products) ? data.products : [];
            products.forEach(function(product) { ids.push(String(product.id)); });
            if (products.length === 250) {
              page += 1;
              return loadPage();
            }
            return ids;
          });
        }
        return loadPage();
      })).then(function(collections) {
        var ids = {};
        collections.forEach(function(collectionIds) {
          collectionIds.forEach(function(id) { ids[id] = true; });
        });
        return ids;
      });
  }

  function getGiftCollectionProductIds() {
    if (!giftCollectionProductsPromise) {
      giftCollectionProductsPromise = getCollectionProductIds(giftCampaignCollections);
    }
    return giftCollectionProductsPromise;
  }

  function getGiftRewardProductIds() {
    if (!giftRewardProductsPromise) {
      giftRewardProductsPromise = getCollectionProductIds(giftCampaignRewardCollections);
    }
    return giftRewardProductsPromise;
  }

  function renderGiftCampaign(cartData) {
    if (!giftCampaignEnabled || !giftCampaignCollections.length) return Promise.resolve();
    var mount = document.getElementById('cart-drawer-gift-offer');
    if (!mount) return Promise.resolve();
    var renderToken = ++giftCampaignRenderToken;

    return getGiftCollectionProductIds().then(function(eligibleIds) {
      if (renderToken !== giftCampaignRenderToken) return;
      var eligibleQuantity = 0;
      (cartData.items || []).forEach(function(item) {
        if (!isCampaignGift(item) && eligibleIds[String(item.product_id)]) eligibleQuantity += Number(item.quantity || 0);
      });

      var giftItems = (cartData.items || []).filter(isCampaignGift);
      if (eligibleQuantity < giftCampaignMinQuantity) {
        mount.innerHTML = '';
        if (giftItems.length && !giftCampaignSyncing) {
          giftCampaignSyncing = true;
          var updates = {};
          giftItems.forEach(function(item) { updates[item.key] = 0; });
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          }).then(function(res) {
            if (!res.ok) throw new Error('Não foi possível remover o brinde da promoção');
            return res.json();
          }).then(function(updatedCart) {
            giftCampaignSyncing = false;
            fetchCartAndRender();
            return updatedCart;
          }).catch(function(error) {
            giftCampaignSyncing = false;
            console.error('[CartDrawer] Erro ao sincronizar brinde:', error);
          });
        }
        return;
      }

      if (giftItems.some(function(item) { return Number(item.final_line_price) === 0; })) {
        mount.innerHTML = '';
        return;
      }

      return getGiftRewardProductIds().then(function(rewardIds) {
        if (renderToken !== giftCampaignRenderToken) return;
        var hasFreeReward = (cartData.items || []).some(function(item) {
          return rewardIds[String(item.product_id)] && Number(item.final_line_price) === 0;
        });
        if (hasFreeReward) {
          mount.innerHTML = '';
          return;
        }

        mount.innerHTML = '<section class="cart-drawer-gift-card" data-gift-campaign>' +
          '<p class="cart-drawer-gift-card__title">Você ganhou um brinde grátis</p>' +
          '<a href="' + escapeHtml(giftCampaignDestinationUrl) + '" class="cart-drawer-gift-card__link">Selecionar brinde</a>' +
          '</section>';
      });
    }).catch(function(error) {
      console.error('[CartDrawer] Erro ao verificar campanha de brinde:', error);
    });
  }

  function getProductImageUrl(item) {
    if (item.image) return item.image.replace(/_(small|medium|large)\./, '_160x.');
    if (item.featured_image && item.featured_image.url) return item.featured_image.url.replace(/_(small|medium|large)\./, '_160x.');
    return '';
  }

  function renderShippingProgress(cartData) {
    var percent = Math.min(100, Math.round((cartData.total_price / freeShippingThreshold) * 100));
    var message;
    if (cartData.total_price >= freeShippingThreshold) {
      message = 'Parabéns! Você ganhou <span class="font-semibold text-gray-900">Frete Grátis</span>';
    } else {
      var remaining = freeShippingThreshold - cartData.total_price;
      message = 'Faltam <span class="font-semibold text-gray-900">' + formatMoney(remaining) + '</span> para o frete grátis';
    }
    return (
      '<div class="px-6 pt-5 pb-2">' +
        '<div class="w-full h-1.5 bg-gray-100 rounded-full overflow-hidden mb-2">' +
          '<div class="cart-shipping-progress h-full bg-gray-900 rounded-full transition-all duration-500" style="width: ' + percent + '%;"></div>' +
        '</div>' +
        '<p class="text-xs text-gray-600">' + message + '</p>' +
      '</div>'
    );
  }

  function renderItems(cartData) {
    var html = '<div id="cart-drawer-gift-offer"></div><div class="px-6 py-4 space-y-6">';
    cartData.items.forEach(function(item, index) {
      var line = index + 1;
      var variantTitle = getVariantTitle(item);
      var kitHtml = getKitPropertiesHtml(item, variantTitle);
      var imageUrl = getProductImageUrl(item);
      var linePrice = item.final_line_price != null ? item.final_line_price : item.line_price;
      var priceHtml;
      var imageHtml = imageUrl
        ? '<img src="' + imageUrl + '" alt="' + (item.image_alt || '').replace(/"/g, '&quot;') + '" class="w-full h-full object-cover" width="80" height="96" loading="lazy">'
        : '<div class="w-full h-full bg-gray-100"></div>';

      if (Number(linePrice) === 0) {
        priceHtml = (
          '<div class="text-right cart-drawer-line-price" data-line="' + line + '">' +
            '<span class="inline-flex items-center rounded bg-green-50 px-2 py-0.5 text-xs font-semibold text-green-700">Grátis</span>' +
          '</div>'
        );
      } else if (pixDiscountPercentage > 0) {
        priceHtml = (
          '<div class="text-right cart-drawer-line-price" data-line="' + line + '">' +
            '<span class="inline-block text-sm font-semibold text-gray-900">' + formatMoney(getPixPrice(linePrice)) + '</span>' +
            renderPixBadge() +
            '<span class="block text-xs font-normal text-gray-400">ou ' + formatMoney(linePrice) + '</span>' +
          '</div>'
        );
      } else {
        priceHtml = (
          '<span class="text-sm font-semibold text-gray-900 cart-drawer-line-price text-right" data-line="' + line + '">' +
            (item.original_line_price > linePrice
              ? '<s class="block text-xs font-normal text-gray-400">' + formatMoney(item.original_line_price) + '</s>'
              : '') +
            formatMoney(linePrice) +
          '</span>'
        );
      }

      html += (
        '<div class="flex gap-4" data-cart-item data-line="' + line + '">' +
          '<a href="' + item.url + '" class="w-20 h-24 bg-gray-50 flex-shrink-0 overflow-hidden flex items-center justify-center">' + imageHtml + '</a>' +
          '<div class="flex-1 min-w-0 flex flex-col justify-between">' +
            '<div>' +
              '<div class="flex items-start justify-between gap-2">' +
                '<a href="' + item.url + '" class="text-sm font-medium text-gray-900 leading-tight hover:text-gray-600 transition-colors line-clamp-2">' + item.product_title + '</a>' +
                '<button type="button" class="cart-drawer-remove p-1 text-gray-400 hover:text-red-500 transition-colors flex-shrink-0 cursor-pointer" data-line="' + line + '" aria-label="Remover ' + item.product_title.replace(/"/g, '&quot;') + '">' +
                  '<svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6"/><path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/><line x1="10" x2="10" y1="11" y2="17"/><line x1="14" x2="14" y1="11" y2="17"/></svg>' +
                '</button>' +
              '</div>' +
              (kitHtml ? kitHtml : (variantTitle ? '<p class="text-xs text-gray-500 mt-0.5">' + variantTitle + '</p>' : '')) +
            '</div>' +
            '<div class="flex items-center justify-between mt-2">' +
              '<div class="flex items-center border border-gray-200">' +
                '<button type="button" class="cart-drawer-qty-btn w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-50 transition-colors cursor-pointer" data-action="decrease" data-line="' + line + '" aria-label="Diminuir quantidade">' +
                  '<svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/></svg>' +
                '</button>' +
                '<span class="cart-drawer-qty-value w-8 text-center text-sm text-gray-900" data-line="' + line + '">' + item.quantity + '</span>' +
                '<button type="button" class="cart-drawer-qty-btn w-8 h-8 flex items-center justify-center text-gray-500 hover:text-gray-900 hover:bg-gray-50 transition-colors cursor-pointer" data-action="increase" data-line="' + line + '" aria-label="Aumentar quantidade">' +
                  '<svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>' +
                '</button>' +
              '</div>' +
              priceHtml +
            '</div>' +
          '</div>' +
        '</div>'
      );
    });
    html += '</div>';
    html += '<div id="cart-drawer-recommendations" class="min-h-[1px]"></div>';
    return html;
  }

  function renderEmptyState() {
    return (
      '<div class="flex-1 flex flex-col items-center justify-center px-6 py-12 text-center">' +
        '<svg class="w-12 h-12 text-gray-300 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">' +
          '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"/>' +
        '</svg>' +
        '<p class="text-sm text-gray-500 mb-6">Seu carrinho está vazio.</p>' +
        '<a href="/collections/all" class="inline-flex items-center justify-center px-6 py-3 bg-black text-white text-sm font-medium hover:bg-gray-800 transition-colors">' +
          'Continuar comprando' +
        '</a>' +
      '</div>'
    );
  }

  function renderFooter(cartData) {
    var savedDiscountCode = getActiveDiscountCode(cartData);
    var discountInfo = getDiscountDescription(cartData, savedDiscountCode);
    var hasAppliedDiscount = discountInfo ? discountInfo.applicable !== false : false;
    var totalDiscount = Math.max(0, Number(cartData.total_discount || 0));
    var originalTotal = Number(cartData.original_total_price || 0) || (Number(cartData.total_price || 0) + totalDiscount);
    var discountStatus = hasAppliedDiscount
      ? '<p id="cart-drawer-discount-status" class="mt-2 text-xs text-gray-600">Cupom <span class="font-semibold text-gray-900">' + escapeHtml(savedDiscountCode) + '</span> aplicado. Os descontos são validados no checkout.</p>'
      : '<p id="cart-drawer-discount-status" class="mt-2 text-xs text-gray-500">Digite um cupom ou use a sugestão abaixo.</p>';
    var appliedDiscountHtml = hasAppliedDiscount
      ? '<div class="mt-3 flex flex-wrap items-center gap-2">' +
          '<span class="inline-flex items-center gap-2 rounded border border-gray-200 px-2.5 py-1.5 text-xs text-gray-900">' +
            '<span class="font-semibold tracking-wide">' + escapeHtml(savedDiscountCode) + '</span>' +
            '<span class="text-gray-500">Aplicado</span>' +
            '<button type="button" id="cart-drawer-discount-remove" class="text-gray-400 hover:text-red-500 cursor-pointer" aria-label="Remover cupom ' + escapeHtml(savedDiscountCode) + '">&times;</button>' +
          '</span>' +
        '</div>'
      : '';
    var cartTotalHtml = '<div class="px-6 py-3 space-y-2">';

    if (totalDiscount > 0) {
      cartTotalHtml +=
        '<div class="flex items-center justify-between gap-4">' +
          '<span class="text-xs text-gray-500">Subtotal</span>' +
          '<span class="text-xs text-gray-500">' + formatMoney(originalTotal) + '</span>' +
        '</div>' +
        '<div class="flex items-center justify-between gap-4">' +
          '<span class="text-xs text-green-700">Desconto</span>' +
          '<span class="text-xs font-semibold text-green-700">-' + formatMoney(totalDiscount) + '</span>' +
        '</div>';
    }

    cartTotalHtml += pixDiscountPercentage > 0
      ? '<div class="flex items-center justify-between gap-4">' +
          '<span class="text-sm font-medium text-gray-900">Total</span>' +
          '<div class="flex items-center justify-end gap-2">' +
            '<span class="inline-flex items-center rounded bg-green-50 px-2 py-0.5 text-xs font-semibold text-green-700">no PIX</span>' +
            '<span id="cart-drawer-subtotal" class="text-sm font-semibold text-gray-900">' + formatMoney(getPixPrice(cartData.total_price)) + '</span>' +
          '</div>' +
        '</div>' +
        '<div class="flex items-center justify-end text-xs text-gray-500">ou ' + formatMoney(cartData.total_price) + '</div>'
      : '<div class="flex items-center justify-between gap-4">' +
          '<span class="text-sm font-medium text-gray-900">Total</span>' +
          '<span id="cart-drawer-subtotal" class="text-sm font-semibold text-gray-900">' + formatMoney(cartData.total_price) + '</span>' +
        '</div>';

    cartTotalHtml += '</div>';

    return (
      '<div class="border-b border-gray-100">' +
        '<button type="button" id="cart-drawer-discount-toggle" class="w-full flex items-center justify-between px-6 py-3 text-sm text-gray-900 hover:bg-gray-50 transition-colors cursor-pointer" aria-expanded="false" aria-controls="cart-drawer-discount-panel">' +
          '<span class="font-medium">Cupom de desconto</span>' +
          '<svg id="cart-drawer-discount-icon" class="w-4 h-4 text-gray-500 transition-transform duration-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>' +
        '</button>' +
        '<div id="cart-drawer-discount-panel" class="hidden px-6 pb-3">' +
          '<div class="flex gap-2">' +
            '<input type="text" id="cart-drawer-discount-code" placeholder="Insira o cupom" value="' + escapeHtml(savedDiscountCode) + '" class="min-w-0 flex-1 h-10 px-3 border border-gray-200 text-sm text-gray-900 placeholder-gray-400 uppercase focus:outline-none focus:border-gray-900 transition-colors">' +
            '<button type="button" id="cart-drawer-discount-apply" class="h-10 px-4 border border-gray-900 text-sm font-medium text-gray-900 hover:bg-gray-900 hover:text-white transition-colors cursor-pointer">Aplicar</button>' +
          '</div>' +
          '<div class="mt-3 flex flex-wrap items-center gap-2">' +
            '<span class="text-xs text-gray-500">Sugestão:</span>' +
            '<button type="button" id="cart-drawer-discount-suggestion" class="px-3 py-1.5 border border-dashed border-gray-300 text-xs font-semibold tracking-wide text-gray-900 hover:border-gray-900 transition-colors cursor-pointer" data-code="' + discountSuggestion + '">' + discountSuggestion + '</button>' +
            '<span class="text-xs text-gray-500">válido para primeira compra</span>' +
          '</div>' +
          appliedDiscountHtml +
          discountStatus +
        '</div>' +
      '</div>' +
      '<div class="border-b border-gray-100">' +
        '<button type="button" id="cart-drawer-shipping-toggle" class="w-full flex items-center justify-between px-6 py-3 text-sm text-gray-900 hover:bg-gray-50 transition-colors cursor-pointer" aria-expanded="false" aria-controls="cart-drawer-shipping-panel">' +
          '<span class="font-medium">Cálculo de frete</span>' +
          '<svg id="cart-drawer-shipping-icon" class="w-4 h-4 text-gray-500 transition-transform duration-200" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M12 5v14"/></svg>' +
        '</button>' +
        '<div id="cart-drawer-shipping-panel" class="hidden px-6 pb-3">' +
          '<div class="flex gap-2">' +
            '<input type="text" id="cart-drawer-shipping-cep" placeholder="00000-000" maxlength="9" class="flex-1 h-10 px-3 border border-gray-200 text-sm text-gray-900 placeholder-gray-400 focus:outline-none focus:border-gray-900 transition-colors">' +
            '<button type="button" id="cart-drawer-shipping-calc" class="h-10 px-4 border border-gray-900 text-sm font-medium text-gray-900 hover:bg-gray-900 hover:text-white transition-colors cursor-pointer">Calcular</button>' +
          '</div>' +
          '<div id="cart-drawer-shipping-results" class="mt-3 space-y-2"></div>' +
        '</div>' +
      '</div>' +
      cartTotalHtml +
      '<div class="px-6 pb-4 pt-1 space-y-2">' +
        '<a href="' + getCheckoutUrl() + '" class="block w-full px-4 py-3 bg-gray-900 text-white text-sm font-medium text-center hover:bg-gray-800 transition-colors" data-cart-drawer-checkout>Finalizar compra</a>' +
        '<button type="button" id="cart-drawer-continue" class="block w-full px-4 py-1.5 text-sm text-gray-600 text-center hover:text-gray-900 transition-colors cursor-pointer">Continue comprando</button>' +
      '</div>'
    );
  }

  function bindDiscountToggle() {
    var toggle = document.getElementById('cart-drawer-discount-toggle');
    var panel = document.getElementById('cart-drawer-discount-panel');
    var icon = document.getElementById('cart-drawer-discount-icon');
    if (toggle && panel) {
      toggle.addEventListener('click', function() {
        var isExpanded = panel.classList.toggle('hidden') === false;
        toggle.setAttribute('aria-expanded', isExpanded);
        if (icon) {
          icon.style.transform = isExpanded ? 'rotate(45deg)' : '';
        }
      });
    }
  }

  function openDiscountPanel() {
    var toggle = document.getElementById('cart-drawer-discount-toggle');
    var panel = document.getElementById('cart-drawer-discount-panel');
    var icon = document.getElementById('cart-drawer-discount-icon');
    if (!toggle || !panel) return;
    panel.classList.remove('hidden');
    toggle.setAttribute('aria-expanded', 'true');
    if (icon) icon.style.transform = 'rotate(45deg)';
  }

  function setDiscountStatus(message, isError) {
    var status = document.getElementById('cart-drawer-discount-status');
    if (!status) return;
    status.className = 'mt-2 text-xs ' + (isError ? 'text-red-500' : 'text-gray-600');
    status.innerHTML = message;
  }

  function bindDiscountCode() {
    var input = document.getElementById('cart-drawer-discount-code');
    var applyBtn = document.getElementById('cart-drawer-discount-apply');
    var suggestionBtn = document.getElementById('cart-drawer-discount-suggestion');
    var removeBtn = document.getElementById('cart-drawer-discount-remove');

    if (input) {
      input.addEventListener('input', function(event) {
        event.target.value = normalizeDiscountCode(event.target.value);
      });
    }

    function setDiscountButtonLoading(loading) {
      if (!applyBtn) return;
      applyBtn.disabled = loading;
      applyBtn.textContent = loading ? 'Aplicando...' : 'Aplicar';
      applyBtn.classList.toggle('opacity-60', loading);
      applyBtn.classList.toggle('cursor-wait', loading);
    }

    function applyCode(value) {
      var code = normalizeDiscountCode(value);
      if (!code) {
        saveDiscountCode('');
        setDiscountStatus('Digite um cupom válido.', true);
        if (input) input.focus();
        return;
      }
      setDiscountButtonLoading(true);
      setDiscountStatus('Aplicando cupom...', false);
      updateCartDiscount(code)
        .then(function(cartData) {
          var discountInfo = getDiscountDescription(cartData, code);
          if (!discountInfo || discountInfo.applicable === false) {
            saveDiscountCode('');
            return updateCartDiscount('').then(function(cleanCartData) {
              renderDrawer(cleanCartData);
              openDiscountPanel();
              setDiscountStatus('Cupom não aplicável para este carrinho.', true);
              var nextInput = document.getElementById('cart-drawer-discount-code');
              if (nextInput) {
                nextInput.value = code;
                nextInput.focus();
              }
            });
          }

          saveDiscountCode(code);
          window.currentCartData = cartData;
          renderDrawer(cartData);
          openDiscountPanel();
          setDiscountStatus('Cupom <span class="font-semibold text-gray-900">' + escapeHtml(code) + '</span> aplicado. Os descontos são validados no checkout.', false);
        })
        .catch(function(err) {
          console.error('[CartDrawer] Erro ao aplicar cupom:', err);
          setDiscountStatus('Erro ao aplicar cupom. Tente novamente.', true);
        })
        .finally(function() {
          setDiscountButtonLoading(false);
        });
    }

    function removeCode() {
      setDiscountStatus('Removendo cupom...', false);
      if (removeBtn) {
        removeBtn.disabled = true;
        removeBtn.classList.add('opacity-60');
      }
      updateCartDiscount('')
        .then(function(cartData) {
          saveDiscountCode('');
          window.currentCartData = cartData;
          renderDrawer(cartData);
          openDiscountPanel();
          setDiscountStatus('Cupom removido.', false);
        })
        .catch(function(err) {
          console.error('[CartDrawer] Erro ao remover cupom:', err);
          setDiscountStatus('Erro ao remover cupom. Tente novamente.', true);
        });
    }

    if (applyBtn && input) {
      applyBtn.addEventListener('click', function() {
        applyCode(input.value);
      });
      input.addEventListener('keydown', function(event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyCode(input.value);
        }
      });
    }

    if (suggestionBtn) {
      suggestionBtn.addEventListener('click', function() {
        applyCode(suggestionBtn.getAttribute('data-code'));
      });
    }

    if (removeBtn) {
      removeBtn.addEventListener('click', function(event) {
        event.preventDefault();
        removeCode();
      });
    }
  }

  function bindShippingToggle() {
    var toggle = document.getElementById('cart-drawer-shipping-toggle');
    var panel = document.getElementById('cart-drawer-shipping-panel');
    var icon = document.getElementById('cart-drawer-shipping-icon');
    if (toggle && panel) {
      toggle.addEventListener('click', function() {
        var isExpanded = panel.classList.toggle('hidden') === false;
        toggle.setAttribute('aria-expanded', isExpanded);
        if (icon) {
          icon.style.transform = isExpanded ? 'rotate(45deg)' : '';
        }
      });
    }
  }

  function bindShippingCalc() {
    var btn = document.getElementById('cart-drawer-shipping-calc');
    var input = document.getElementById('cart-drawer-shipping-cep');
    var results = document.getElementById('cart-drawer-shipping-results');
    if (input) {
      var savedCep = getSavedCep();
      if (savedCep) input.value = formatCep(savedCep);

      input.addEventListener('input', function(e) {
        var cep = normalizeCep(e.target.value);
        e.target.value = formatCep(cep);
        if (cep.length === 8) saveCep(cep);
      });

      if (!shippingCepSyncBound) {
        shippingCepSyncBound = true;
        document.addEventListener('snap:shipping-cep:updated', function(event) {
          var cep = event.detail && event.detail.cep;
          var currentInput = document.getElementById('cart-drawer-shipping-cep');
          if (cep && currentInput && document.activeElement !== currentInput) {
            currentInput.value = formatCep(cep);
          }
        });
      }
    }
    if (btn && input) {
      btn.addEventListener('click', function() {
        var cep = normalizeCep(input.value);
        if (cep.length !== 8) {
          if (results) results.innerHTML = '<p class="text-xs text-red-500">Digite um CEP válido.</p>';
          return;
        }

        if (window.currentCartData && window.currentCartData.item_count === 0) {
          if (results) results.innerHTML = '<p class="text-xs text-gray-500">Adicione um produto ao carrinho para calcular o frete.</p>';
          return;
        }

        saveCep(cep);
        btn.disabled = true;
        if (results) results.innerHTML = '<p class="text-xs text-gray-500">Calculando...</p>';

        calculateShippingRates(cep)
          .then(function(rates) {
            if (results) results.innerHTML = renderShippingRates(rates);
          })
          .catch(function(err) {
            console.error('[CartDrawer] Erro ao calcular frete:', err);
            if (results) {
              results.innerHTML = '<p class="text-xs text-red-500">Erro ao calcular o frete. Tente novamente.</p>';
            }
          })
          .finally(function() {
            btn.disabled = false;
          });
      });
    }
  }

  function bindContinueButton() {
    var btn = document.getElementById('cart-drawer-continue');
    if (btn) {
      btn.addEventListener('click', closeDrawer);
    }
  }

  function bindCheckoutButton() {
    var checkoutBtn = document.querySelector('[data-cart-drawer-checkout]');
    if (!checkoutBtn) return;

    updateCheckoutDiscountLink();
    checkoutBtn.addEventListener('click', function() {
      var input = document.getElementById('cart-drawer-discount-code');
      if (input && normalizeDiscountCode(input.value)) {
        saveDiscountCode(input.value);
      }
      updateCheckoutDiscountLink();
    });
  }

  function bindQuantityButtons() {
    if (!drawerBody) return;
    drawerBody.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-drawer-qty-btn');
      if (!btn) return;

      var line = parseInt(btn.getAttribute('data-line'), 10);
      var action = btn.getAttribute('data-action');
      var qtyEl = document.querySelector('.cart-drawer-qty-value[data-line="' + line + '"]');
      if (!qtyEl) return;

      var currentQty = parseInt(qtyEl.textContent, 10);
      var newQty = action === 'increase' ? currentQty + 1 : currentQty - 1;

      if (newQty < 1) {
        changeQuantity(line, 0);
        var itemRow = document.querySelector('[data-cart-item][data-line="' + line + '"]');
        if (itemRow) itemRow.style.opacity = '0.5';
      } else {
        changeQuantity(line, newQty);
      }
    });
  }

  function bindRemoveButtons() {
    if (!drawerBody) return;
    drawerBody.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-drawer-remove');
      if (!btn) return;

      var line = parseInt(btn.getAttribute('data-line'), 10);
      changeQuantity(line, 0);

      var itemRow = document.querySelector('[data-cart-item][data-line="' + line + '"]');
      if (itemRow) {
        itemRow.style.opacity = '0.5';
        itemRow.style.pointerEvents = 'none';
      }
    });
  }

  function renderDrawer(cartData) {
    if (!drawerBody) return;

    window.currentCartData = cartData;
    var cartDiscountCodes = getCartDiscountCodes(cartData, true);
    if (cartDiscountCodes.length > 0) saveDiscountCode(cartDiscountCodes[0]);

    if (cartData.item_count === 0) {
      drawerBody.innerHTML = renderEmptyState();
      if (drawerFooter) drawerFooter.style.display = 'none';
    } else {
      drawerBody.innerHTML = renderShippingProgress(cartData) + renderItems(cartData);
      requestAnimationFrame(function() {
        var bar = document.querySelector('.cart-shipping-progress');
        if (bar) {
          bar.classList.remove('shipping-bar-animate');
          void bar.offsetWidth; // força reflow
          bar.classList.add('shipping-bar-animate');
        }
      });
      if (!drawerFooter && drawerContent) {
        drawerFooter = document.createElement('div');
        drawerFooter.id = 'cart-drawer-footer';
        drawerFooter.className = 'border-t border-gray-100 bg-white flex-shrink-0';
        drawerContent.appendChild(drawerFooter);
      }
      if (drawerFooter) {
        drawerFooter.style.display = '';
        drawerFooter.innerHTML = renderFooter(cartData);
      }
      bindDiscountToggle();
      bindDiscountCode();
      bindShippingToggle();
      bindShippingCalc();
      bindContinueButton();
      bindCheckoutButton();
    }

    updateCartBadge(cartData.item_count);
  }

  function updateCartBadge(count) {
    var itemCount = Math.max(0, Number(count) || 0);
    document.querySelectorAll('header button[data-cart-drawer-toggle]').forEach(function(button) {
      var badge = button.querySelector('[data-cart-count]');
      if (!badge && itemCount > 0) {
        badge = document.createElement('span');
        badge.setAttribute('data-cart-count', '');
        badge.className = 'absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 bg-[#6B8E4E] text-white text-[10px] font-bold flex items-center justify-center rounded-full';
        button.appendChild(badge);
      }
      if (badge) {
        badge.textContent = itemCount;
        badge.style.display = itemCount > 0 ? '' : 'none';
      }
    });
  }

  function fetchCartAndRender(callback) {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function(res) { return res.json(); })
      .then(function(cartData) {
        window.currentCartData = cartData;
        renderDrawer(cartData);
        if (typeof callback === 'function') callback();
      })
      .catch(function(err) {
        console.error('[CartDrawer] Erro ao buscar carrinho:', err);
        if (typeof callback === 'function') callback();
      });
  }

  function setItemLoading(line, loading) {
    var item = document.querySelector('[data-cart-item][data-line="' + line + '"]');
    if (!item) return;
    if (loading) {
      item.classList.add('opacity-50', 'pointer-events-none');
      var spinner = item.querySelector('.cart-item-spinner');
      if (!spinner) {
        spinner = document.createElement('div');
        spinner.className = 'cart-item-spinner absolute inset-0 flex items-center justify-center bg-white/30 z-10';
        spinner.innerHTML = '<svg class="animate-spin h-5 w-5 text-gray-900" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>';
        item.appendChild(spinner);
      }
    } else {
      item.classList.remove('opacity-50', 'pointer-events-none');
      var spinner = item.querySelector('.cart-item-spinner');
      if (spinner) spinner.remove();
    }
  }

  function changeQuantity(line, quantity) {
    var currentItems = window.currentCartData && Array.isArray(window.currentCartData.items)
      ? window.currentCartData.items
      : [];
    var previousItem = currentItems[line - 1] || null;
    var kitId = quantity === 0 ? getKitId(previousItem) : null;
    var itemsToRemove = kitId
      ? currentItems.filter(function(item) { return getKitId(item) === kitId; })
      : [];

    // Kit components are separate Shopify lines. Remove every component in one
    // update so the discount cannot remain active on orphaned kit items.
    var updatePayload = null;
    if (itemsToRemove.length > 0) {
      updatePayload = { updates: {} };
      itemsToRemove.forEach(function(item) {
        var itemIndex = currentItems.indexOf(item) + 1;
        var itemKey = item.key || String(itemIndex);
        updatePayload.updates[itemKey] = 0;
        setItemLoading(itemIndex, true);
      });
    } else {
      setItemLoading(line, true);
    }

    var requestUrl = updatePayload ? '/cart/update.js' : '/cart/change.js';
    var requestBody = updatePayload || { line: line, quantity: quantity };

    fetch(requestUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(requestBody)
    })
      .then(function(res) {
        return res.json().then(function(data) {
          if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Cart update failed');
          return data;
        });
      })
      .then(function(cartData) {
        window.currentCartData = cartData;
        renderDrawer(cartData);
        if (typeof window.urboDataLayer !== 'undefined' && window.urboDataLayer.pushEcommerceEvent && window.urboDataLayer.buildItemFromCartItem) {
          if (itemsToRemove.length > 0) {
            var kitItems = itemsToRemove.map(function(item) {
              return window.urboDataLayer.buildItemFromCartItem(item);
            }).filter(Boolean);
            if (kitItems.length > 0) {
              window.urboDataLayer.pushEcommerceEvent('remove_from_cart', kitItems, {
                currency: 'BRL',
                value: parseFloat(kitItems.reduce(function(total, item) {
                  return total + (item.price * item.quantity);
                }, 0).toFixed(2))
              });
            }
          } else if (previousItem) {
            var item = window.urboDataLayer.buildItemFromCartItem(previousItem);
            if (item) {
              var qtyDiff = quantity - previousItem.quantity;
              if (quantity === 0) {
                window.urboDataLayer.pushEcommerceEvent('remove_from_cart', [item], {
                  currency: 'BRL',
                  value: parseFloat((item.price * previousItem.quantity).toFixed(2))
                });
              } else if (qtyDiff > 0) {
                item.quantity = qtyDiff;
                window.urboDataLayer.pushEcommerceEvent('add_to_cart', [item], { currency: 'BRL', source: 'cart_drawer' });
              } else if (qtyDiff < 0) {
                item.quantity = Math.abs(qtyDiff);
                window.urboDataLayer.pushEcommerceEvent('remove_from_cart', [item], {
                  currency: 'BRL',
                  value: parseFloat((item.price * Math.abs(qtyDiff)).toFixed(2))
                });
              }
            }
          }
        }
      })
      .catch(function(err) {
        console.error('[CartDrawer] Erro ao atualizar quantidade:', err);
        if (itemsToRemove.length > 0) {
          itemsToRemove.forEach(function(item) {
            setItemLoading(currentItems.indexOf(item) + 1, false);
          });
        } else {
          setItemLoading(line, false);
        }
      });
  }

  function openDrawer() {
    if (!drawer) return;

    if (isOpen) {
      fetchCartAndRender();
      return;
    }

    isOpen = true;
    drawer.style.display = 'block';
    drawer.setAttribute('aria-hidden', 'false');

    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        if (drawerContent) {
          drawerContent.classList.remove('translate-x-full');
        }
      });
    });

    document.body.style.overflow = 'hidden';
    fetchCartAndRender();
  }

  function closeDrawer() {
    if (!drawer || !isOpen) return;
    isOpen = false;
    if (drawerContent) {
      drawerContent.classList.add('translate-x-full');
    }
    setTimeout(function() {
      drawer.style.display = 'none';
      drawer.setAttribute('aria-hidden', 'true');
    }, 300);
    document.body.style.overflow = '';
    // Reseta o cache de recomendações para que reabram corretamente
    lastRecommendedProductId = null;
  }

  // Event bindings fixos
  if (backdrop) {
    backdrop.addEventListener('click', closeDrawer);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeDrawer);
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer && drawer.style.display !== 'none') {
      closeDrawer();
    }
  });

  // Bind direto nos toggles ao invés de delegação
  function bindToggles() {
    var toggles = document.querySelectorAll('[data-cart-drawer-toggle]');
    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        openDrawer();
      });
    });
  }

  bindToggles();
  bindQuantityButtons();
  bindRemoveButtons();
  bindDiscountToggle();
  bindDiscountCode();
  bindCheckoutButton();

  // ============================================================
  // RECOMMENDATIONS — Cart Drawer Smart Upsells
  // ============================================================

  var recommendationsContainer = document.getElementById('cart-drawer-recommendations');
  var recommendationsLoading = false;
  var lastRecommendedProductId = null;

  function getCartProductIds(cartData) {
    var ids = [];
    cartData.items.forEach(function(item) {
      if (item.product_id) ids.push(item.product_id);
    });
    return ids;
  }

  function filterOutCartProducts(html, cartProductIds) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var cards = doc.querySelectorAll('[data-cart-recommendation-card]');
    var visibleCount = 0;

    cards.forEach(function(card) {
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      if (cartProductIds.indexOf(pid) !== -1) {
        card.remove();
      } else {
        visibleCount++;
      }
    });

    if (visibleCount === 0) return '';

    var wrapper = doc.querySelector('[data-cart-recommendations]');
    return wrapper ? wrapper.outerHTML : '';
  }

  function bindRecommendationSizeButtons() {
    if (!recommendationsContainer) return;

    recommendationsContainer.querySelectorAll('.cart-rec-size-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var card = btn.closest('[data-cart-recommendation-card]');
        if (!card) return;

        var sizeButtons = card.querySelectorAll('.cart-rec-size-btn');
        var addButton = card.querySelector('.cart-rec-add-btn');

        sizeButtons.forEach(function(b) {
          b.classList.remove('border-gray-900', 'bg-gray-900', 'text-white');
          b.classList.add('border-gray-300', 'text-gray-900');
        });
        btn.classList.remove('border-gray-300', 'text-gray-900');
        btn.classList.add('border-gray-900', 'bg-gray-900', 'text-white');

        if (addButton) {
          addButton.setAttribute('data-variant-id', btn.getAttribute('data-variant-id'));
          addButton.disabled = false;
        }
      });
    });
  }

  function bindRecommendationButtons() {
    if (!recommendationsContainer) return;

    recommendationsContainer.querySelectorAll('.cart-rec-add-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        if (btn.disabled) return;

        var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
        var productTitle = btn.getAttribute('data-product-title') || 'Produto';

        // Estado de loading
        btn.disabled = true;
        btn.querySelector('.btn-text').classList.add('hidden');
        btn.querySelector('.btn-spinner').classList.remove('hidden');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              '_source': 'cart_recommendation'
            }
          })
        })
          .then(function(res) {
            if (!res.ok) throw new Error('Add failed');
            return res.json();
          })
          .then(function(data) {
            if (typeof window.urboDataLayer !== 'undefined' && window.urboDataLayer.pushEcommerceEvent && data && data.items && data.items.length > 0) {
              var addedItem = data.items[data.items.length - 1];
              var item = window.urboDataLayer.buildItemFromCartItem(addedItem);
              if (item) {
                window.urboDataLayer.pushEcommerceEvent('add_to_cart', [item], {
                  currency: 'BRL',
                  source: 'cart_recommendation'
                });
              }
            }
            // Atualiza o drawer inteiro
            fetchCartAndRender(function() {
              // Feedback visual no botão
              btn.querySelector('.btn-spinner').classList.add('hidden');
              btn.querySelector('.btn-text').textContent = 'Adicionado!';
              btn.querySelector('.btn-text').classList.remove('hidden');
              btn.classList.remove('bg-gray-900', 'hover:bg-gray-800');
              btn.classList.add('bg-green-600', 'hover:bg-green-700');

              // Notificação discreta
              showNotification(productTitle + ' adicionado ao carrinho');

              setTimeout(function() {
                btn.querySelector('.btn-text').textContent = 'Adicionar';
                btn.classList.remove('bg-green-600', 'hover:bg-green-700');
                btn.classList.add('bg-gray-900', 'hover:bg-gray-800');
                btn.disabled = false;
              }, 2000);
            });
          })
          .catch(function(err) {
            console.error('[CartRecommendations] Erro ao adicionar:', err);
            btn.querySelector('.btn-spinner').classList.add('hidden');
            btn.querySelector('.btn-text').textContent = 'Erro';
            btn.querySelector('.btn-text').classList.remove('hidden');
            btn.disabled = false;

            setTimeout(function() {
              btn.querySelector('.btn-text').textContent = 'Adicionar';
            }, 2000);
          });
      });
    });
  }

  function showNotification(message) {
    if (window.showNotification && typeof window.showNotification === 'function') {
      window.showNotification(message);
      return;
    }
    // Fallback simples
    var existing = document.getElementById('cart-drawer-notification');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.id = 'cart-drawer-notification';
    el.className = 'fixed bottom-4 left-1/2 -translate-x-1/2 z-[200] bg-gray-900 text-white text-sm px-4 py-2.5 rounded-lg shadow-lg flex items-center gap-2';
    el.innerHTML = '<svg class="w-4 h-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/></svg>' + message;
    document.body.appendChild(el);

    setTimeout(function() {
      el.style.opacity = '0';
      el.style.transition = 'opacity 0.3s';
      setTimeout(function() { el.remove(); }, 300);
    }, 2500);
  }

  function loadRecommendations(cartData) {
    if (!recommendationsContainer || recommendationsLoading) return;
    if (!cartData || cartData.item_count === 0) {
      recommendationsContainer.innerHTML = '';
      return;
    }

    // Usa o primeiro item como produto principal para recomendações
    var primaryItem = cartData.items[0];
    var primaryProductId = primaryItem.product_id;

    if (!primaryProductId) return;

    // Evita reload se o produto principal não mudou e o container ainda tem conteúdo
    if (lastRecommendedProductId === primaryProductId) {
      var cartProductIds = getCartProductIds(cartData);
      var cards = recommendationsContainer.querySelectorAll('[data-cart-recommendation-card]');

      // Se o container estiver vazio (DOM foi recriado), força o recarregamento
      if (cards.length === 0) {
        lastRecommendedProductId = null;
        loadRecommendations(cartData);
        return;
      }

      cards.forEach(function(card) {
        var pid = parseInt(card.getAttribute('data-product-id'), 10);
        if (cartProductIds.indexOf(pid) !== -1) {
          card.style.display = 'none';
        }
      });
      return;
    }

    recommendationsLoading = true;
    lastRecommendedProductId = primaryProductId;

    var sectionId = 'cart-recommendations';
    var url = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'recommendations/products?section_id=' + sectionId + '&product_id=' + primaryProductId + '&limit=10&intent=complementary'
      : '/recommendations/products?section_id=' + sectionId + '&product_id=' + primaryProductId + '&limit=10&intent=complementary';

    fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var cartProductIds = getCartProductIds(cartData);
        var filteredHtml = filterOutCartProducts(html, cartProductIds);

        if (filteredHtml && filteredHtml.trim().length > 0) {
          recommendationsContainer.innerHTML = filteredHtml;
          bindRecommendationSizeButtons();
          bindRecommendationButtons();
        } else {
          recommendationsContainer.innerHTML = '';
        }
      })
      .catch(function(err) {
        console.error('[CartRecommendations] Erro ao carregar:', err);
        recommendationsContainer.innerHTML = '';
      })
      .finally(function() {
        recommendationsLoading = false;
      });
  }

  // Integra recomendações ao ciclo de renderização do drawer
  var originalRenderDrawer = renderDrawer;
  renderDrawer = function(cartData) {
    originalRenderDrawer(cartData);
    // Pequeno delay para garantir que o DOM está pronto
    setTimeout(function() {
      recommendationsContainer = document.getElementById('cart-drawer-recommendations');
      loadRecommendations(cartData);
      renderGiftCampaign(cartData);
    }, 50);
  };

  // Expor globalmente
  window.openCartDrawer = openDrawer;
  window.closeCartDrawer = closeDrawer;
  window.refreshCartDrawer = fetchCartAndRender;
  setInterval(refreshDispatchTimers, 60000);
})();
